import * as React from 'react';
import { NumberPanel } from '@watcherr/ui';
import { t } from '~/i18n';
import connect from '~/store/connect';
import { State } from '~/store/types';
import UserProfileEntry from '~store/Profile/UserProfileEntry';

interface DashboardNumbersContainerProps {
  numberOfResidents: number;
  numberOfResidentGroups: number;
  numberOfhealthcareProviders: number;
  numberOfhealthcareProviderGroups: number;
  loadStats: () => void;
  profile: UserProfileEntry;
}

const DashboardNumbersContainer: React.FC<DashboardNumbersContainerProps> = ({
  numberOfResidents,
  numberOfResidentGroups,
  numberOfhealthcareProviders,
  numberOfhealthcareProviderGroups,
  loadStats,
}) => {
  React.useEffect(() => {
    loadStats();
  }, [loadStats]);
  return (
    <div className="row">
      <div className="col-6 col-md-3">
        <NumberPanel number={numberOfResidents} label={t('dashboard.numbers.residents')} icon="user" />
      </div>
      <div className="col-6 col-md-3">
        <NumberPanel
          number={numberOfResidentGroups}
          label={t('dashboard.numbers.resident_groups')}
          icon="resident-groups"
        />
      </div>
      <div className="col-6 col-md-3">
        <NumberPanel
          number={numberOfhealthcareProviders}
          label={t('dashboard.numbers.healthcare_providers')}
          icon="healthcare-providers"
        />
      </div>
      <div className="col-6 col-md-3">
        <NumberPanel
          number={numberOfhealthcareProviderGroups}
          label={t('dashboard.numbers.healthcare_provider_groups')}
          icon="healthcare-provider-groups"
        />
      </div>
    </div>
  );
};

export default connect((state: State) => ({
  numberOfResidents: state.graphs.global.numberOfResidents,
  numberOfResidentGroups: state.graphs.global.numberOfResidentGroups,
  numberOfhealthcareProviders: state.graphs.global.numberOfhealthcareProviders,
  numberOfhealthcareProviderGroups: state.graphs.global.numberOfhealthcareProviderGroups,
  loadStats: state.graphs.global.loadStats,
  profile: state.auth.user,
}))(DashboardNumbersContainer);
